<template>
<div>
  <template v-if="nowTab === 1">
    <div class="flex flex-wrap justify-center">
      <template v-for="(plan, index) in config.plans">
        <div class="w-full mb-8 lg:mb-0 sm:w-1/2 lg:w-1/3" :key="index">
          <div class="priceTable__item shadow rounded-sm px-16 py-24 mx-4 lg:mb-0">
            <h3 class="text-center font-bold">{{ plan.name }}</h3>
            <div class="text-center">
              <div class="text-blue mt-16 mb-32 font-bold">
                <div v-if="typeof plan.price === 'number'">NT <span class="text-4xl font-bold">{{ plan.price | toThousands }}</span> /月</div>
                <div v-else class="text-2xl font-bold">{{ plan.price }}</div>
              </div>
            </div>
            <div class="mb-24">
              <h6 class="font-bold mb-8">履歷品項</h6>
              <div class="text-blue text-lg font-bold">{{ plan.count }}項</div>
            </div>
            <div>
              <h6 class="font-bold mb-8">服務內容</h6>
              <ul class="text-sm text-grey-darker list-reset leading-md">
                <li>產品溯源履歷頁面</li>
                <li>平台設定</li>
              </ul>
            </div>
            <hr>
            <div class="mb-24 border-t border-grey-lighter pt-16 mt-16">
              <h6 class="font-bold mb-8">加購履歷貼紙</h6>
              <div class="text-blue-dark font-bold">
                  <template>
                    <span class="text-xl">{{ plan.sticker.count | toThousands }}</span>
                    <small class="ml-8">張 (含以內)</small>
                  </template>
                </div>
                <div class="text-sm text-blue-dark font-bold mt-8">NT {{ plan.sticker.price }} /張</div>
                <div class="text-xs text-grey-darker mt-8">首年可享優惠折抵 NT3,600</div>
            </div>
            <button class="btn btn-block btn-solid btn-blue gradient-btn" @click="openContactFormWithPlan($event, plan)">申請專案</button>
          </div>
        </div>
      </template>
    </div>
  </template>
  <template v-if="nowTab === 2">
    <div class="bg-white p-16 rounded">
      <h3 class="text-center font-bold mt-8 mb-16">溯源履歷+IoT裝置方案</h3>
      <div class="flex flex-wrap justify-center">
        <template v-for="(item, index) in config.IoTs">
          <div class="separate-vertical sm:w-1/2 lg:w-1/3 px-8" :key="index">
            <h5 class="font-bold">{{ item.name }}</h5>
            <div class="text-xs leading-xs mt-4 mb-16">{{ item.description }}</div>
            <img :src="item.cover">
          </div>
        </template>
      </div>
      <div class="text-center text-4xl font-bold my-16">
        +
      </div>
      <div class="flex flex-wrap  justify-center">
        <template v-for="(plan, index) in config.plansWithIoTs">
          <div :key="index" class="w-full mb-8 lg:mb-0 sm:w-1/2 lg:w-1/3 px-8">
            <div class="priceTable__item text-left border-b border-grey-lightest md:border-b-0 p-8 md:shadow-none" :class="{'md:border-r mr-0': index < config.plans.length - 1}">
              <h3 class="font-bold">{{ plan.name }}</h3>
              <div>
                <div class="text-blue mt-16 mb-32 font-bold">
                  <div v-if="typeof plan.price === 'number'">NT <span class="text-4xl font-bold">{{ plan.price | toThousands }}</span> /月</div>
                  <div v-else class="text-2xl font-bold">{{ plan.price }}</div>
                </div>
              </div>
              <div class="mb-24">
                <h6 class="font-bold mb-8">履歷品項</h6>
                <div class="text-blue text-lg font-bold">{{ plan.count }} 項</div>
              </div>
              <div>
                <h6 class="font-bold mb-8">服務內容</h6>
                <ul class="text-sm text-grey-darker list-reset leading-md">
                  <li v-for="service in plan.services" :key="service">{{ service }}</li>
                </ul>
              </div>
              <hr>
              <div class="mb-24 pt-16 mt-16">
                <h6 class="font-bold mb-8">加購履歷貼紙</h6>
                <div class="text-blue-dark font-bold">
                  <template>
                    <span class="text-xl">{{ plan.sticker.count | toThousands }}</span>
                    <small class="ml-8">張 (含以內)</small>
                  </template>
                </div>
                <div class="text-sm text-blue-dark font-bold mt-8">NT {{ plan.sticker.price }} /張</div>
                <div class="text-xs text-grey-darker mt-8">首年可享優惠折抵 NT7,200</div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="text-right">
        <button class="btn btn-solid btn-blue gradient-btn" @click="openContactFormWithPlan()">申請IoT專案請來信洽詢</button>
      </div>
    </div>
  </template>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import config from './configs/zhTw'

export default {
  props: {
    nowTab: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      config
    }
  },
  filters: {
    toThousands: function (val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  methods: {
    ...mapActions([
      'openContactForm'
    ]),
    openContactFormWithPlan (event) {
      // plan ? this.openContactForm({ from: 'Agriculture', plan: plan.name }) : this.openContactForm({ from: 'Agriculture' })
      this.openContactForm({ from: 'Agriculture' })
    }
  }
}
</script>
